import { type FC, type ReactNode } from "react";
import { useHookGlobal } from "@/wrappers/hooks/useHookGlobal.tsx";
import { useHookRemoveDeadSessions } from "@/wrappers/hooks/useHookRemoveDeadSessions.tsx";
import { useHookHotLoadingPatch } from "@/wrappers/hooks/useHookHotLoadingPatch.tsx";
import { useHookTutorLogin } from "@/wrappers/hooks/useHookTutorLogin.tsx";
import { useHookSignalrChat } from "@/wrappers/hooks/useHookSignalrChat.tsx";
import { useHookOldSessionFetch } from "@/wrappers/hooks/useHookOldSessionFetch.tsx";
import { useHookNewChat } from "@/wrappers/hooks/useHookNewChat.tsx";
import { useHookAllChatUpdate } from "@/wrappers/hooks/useHookAllChatUpdate.tsx";
import { useHookAiTutor } from "@/wrappers/hooks/useHookAiTutor.tsx";
//import { getPendingResponses } from "@/api/chat.ts";

interface TutorProps {
  children?: ReactNode;
}

export const TutorWrapper: FC<TutorProps> = ({ children }) => {
  useHookNewChat();
  useHookOldSessionFetch();
  useHookSignalrChat();
  useHookTutorLogin();
  useHookHotLoadingPatch();
  useHookRemoveDeadSessions();
  useHookGlobal();
  useHookAllChatUpdate();
  useHookAiTutor();

  //getPendingResponses();

  return <>{children}</>;
};
